<template>
  <div class="tenants-settings-cont">
    <section-title title="Tenants" icon="fas fa-address-card"/>
    <div class="tenants-cont">
      <template v-if="!isLoadingData && (getTenants.length<1)">
        <div class="no-results mt-4">No tenants found</div>
      </template>
      <template v-if="!isLoadingData && (getTenants.length>0) && (getTenantsTree.length>0)">
        <div class="tenants-tree-cont">
          <div
              v-for="(tenantNodeItem, tenantNodeIndex) in getTenantsTree"
              :key="`tenant-node-key-${tenantNodeIndex}`"
              class="text-color tenant-wrap"
          >
            <div class="tenant-row">
              <div class="tenant-item node">
                <div class="tenant-item node__name">
                  <v-icon small class="mr-2">far fa-building</v-icon>
                  {{ tenantNodeItem.name }}
                </div>
                <div class="tenant-item node__action">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          small
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          @click="editTenantHandler(tenantNodeItem.id)"
                      >
                        <v-icon x-small>
                          far fa-edit
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                </div>
              </div>
              <div class="tenant-channels">
                <channels-panel
                    :loading="assigning"
                    :enabled="tenantNodeItem.channels"
                    @toggle="(channelDataArg) => enableChannel(channelDataArg, tenantNodeItem)"
                />
              </div>
            </div>
            <template v-if="(!!tenantNodeItem.children && (tenantNodeItem.children.length > 0))">
              <div
                  v-for="(childTenantItem, childTenantIndex) in tenantNodeItem.children"
                  :key="`child-tenant-key-${childTenantIndex}`"
                  class="tenant-row"
              >
                <div class="tenant-item child">
                  <div class="tenant-item child__name">
                    <v-icon small class="mr-2">fas fa-user-tie</v-icon>
                    {{ childTenantItem.name }}
                  </div>
                  <div class="tenant-item child__action">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            small
                            rounded
                            v-bind="attrs"
                            v-on="on"
                            @click="editTenantHandler(childTenantItem.id)"
                        >
                          <v-icon x-small>
                            far fa-edit
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </div>
                </div>
                <div class="tenant-channels">
                  <channels-panel
                      :loading="assigning"
                      :enabled="childTenantItem.channels"
                      @toggle="(channelDataArg) => enableChannel(channelDataArg, childTenantItem)"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <v-btn
          v-if="(isAdmin === true)"
          fab
          bottom
          right
          :style="{ bottom: '20px' }"
          :color="$vuetify.theme.dark ? '#685AA1' : 'primary'"
          dark
          fixed
          @click="addNewTenantHandler"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <tenant-editor
          :show-dialog="showTenantEditor"
          :tenants-list="tenantsList"
          :tenant-data="tenantData"
          :loading="saving"
          @save="saveTenant"
          @close="closeEditorHandler"
      />
    </div>
  </div>
</template>

<script>
import {NotificationService} from "@/services/ApiService";
import {mapActions, mapGetters} from "vuex";
import TenantEditor from "@/components/Settings/Tenants/TenantEditor.vue";
import ChannelsPanel from "@/components/Settings/Tenants/ChannelsPanel.vue";
import SectionTitle from "@/components/Settings/SectionTitle.vue";

export default {
  name: 'Tenants',
  components: {SectionTitle, ChannelsPanel, TenantEditor},
  data: () => ({
    loading: true,
    saving: false,
    assigning: false,
    tenantsList: [],
    // tenantsTree: [],
    tenantData: {},
    channelTypesList: [],
    channelData: {
      channelTypeTenant: '',
      description: '',
      ownerUsername: '',
      dailyQuota: 0,
      receiverInfo: {}
    },
    showTenantEditor: false,
  }),
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapGetters("notifications", ["isLoadingData", "getTenants", "getTenantsTree", "getChannelTypes"]),
    tenantsTree() {
      if (this.getTenantsTree && this.getTenantsTree.length > 0) {
        return this.getTenantsTree;
      }
      return []
    }
  },
  mounted() {
    // this.fetchTenants();
    this.structureData();
  },
  methods: {
    ...mapActions("notifications", ["prepareData", "constructTenantsTree"]),
    async structureData() {
      await this.prepareData();
      if (!!this.getTenants && this.getTenants.length > 0) {
        await this.constructTenantsTree();
      }
      this.loading = false;
    },
    /**
     * Fetch all tenants as an unsorted/unstructured list
     *
     * @returns {Promise<void>}
     */
    async fetchTenantsBCK() {
      try {
        const tenantsResponse = await NotificationService.Tenants.get();
        // console.log('tenantsResponse');
        // console.log(tenantsResponse);
        if (tenantsResponse.data && (tenantsResponse.data.length > 0)) {
          this.tenantsList = tenantsResponse.data.map(tenantItem => {
            return {
              ...tenantItem,
              channels: [],
            }
          });
        }
        await this.fetchChannels();
        await this.getTenantsActiveChannels();
        this.constructTenantsTree();
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * Fetch all available channel types
     *
     * @returns {Promise<void>}
     */
    async fetchChannels() {
      try {
        const channelTypesResponse = await NotificationService.ChannelTypes.get();
        // console.log('channelTypesResponse.data');
        // console.log(channelTypesResponse.data);
        this.channelTypesList = channelTypesResponse.data;
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    /**
     * Get the Tenants' active channels
     * @returns {Promise<void>}
     */
    async getTenantsActiveChannels() {
      try {
        const activeChannelsResponse = await NotificationService.Channels.getTenantChannels();
        // console.log('activeChannelsResponse.data');
        // console.log(activeChannelsResponse.data);
        // await Promise.all(this.tenantsList.map(item => prepareDataById(item.id)))
        const tenantsChannels = activeChannelsResponse.data;
        const channelsData = {};
        tenantsChannels.forEach(tenantChannelItem => {
          // console.log(`Channel ${tenantChannelItem.channelTypeId} to Tenant "${tenantChannelItem.tenant_id}"`);
          if (!!channelsData[tenantChannelItem.tenant_id]) {
            channelsData[tenantChannelItem.tenant_id].push(tenantChannelItem.channelTypeId);
          } else {
            channelsData[tenantChannelItem.tenant_id] = [tenantChannelItem.channelTypeId];
          }
        });
        this.tenantsList = this.tenantsList.map(tenantItem => {
          if (!!channelsData[tenantItem.id]) {
            return {...tenantItem, channels: channelsData[tenantItem.id]};
          } else {
            return {...tenantItem, channels: []};
          }
        });
        // console.log('updated this.tenantsList');
        // console.log(this.tenantsList);
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * construct a Tree-like structure of Tenants and their child tenants
     */
    constructTenantsTreeBCK() {
      const tenantsArray = this.tenantsList.map(tenantItem => ({...tenantItem, children: []}));

      /**
       * Recursive function to nest Tenants to their corresponding parent tenants
       *
       * @param tenants {Array} the updated tenants array on current recursion
       * @param parent {String} the 'parent' ID of the tenant to nest under
       * @returns {*} an updated tenants list with refined parent tenant for each recursion
       */
      function buildTree(tenants, parent = null) {
        return tenants
            .filter(tenantItem => tenantItem.parent === parent)
            .map(filteredTenantItem => ({
              ...filteredTenantItem,
              children: buildTree(tenants, filteredTenantItem.id)
            }));
      }


      const structuredTenantsArray = buildTree(tenantsArray);
      // console.log('structuredTenantsArray');
      // console.log(structuredTenantsArray);
      function sortItemsRecursively(items) {
        // First, sort the current array of items based on the "name" property
        items.sort((a, b) => a.name.localeCompare(b.name));

        // Now, recursively sort any nested "children" arrays
        items.forEach(item => {
          if (item.children && item.children.length > 0) {
            sortItemsRecursively(item.children);
          }
        });
      }

      sortItemsRecursively(structuredTenantsArray);
      this.tenantsTree = structuredTenantsArray;
    },
    /**
     * handle the add new Tenant button click
     * - opens the Tenant Editor panel/dialog
     */
    addNewTenantHandler() {
      this.tenantData = null;
      this.showTenantEditor = true;
    },

    /**
     * handle the edit tenant event
     * - find the target tenant to edit as specified by the provided ID and
     * add its data to the local tenantData property
     * - open the Tenant Editor dialog
     *
     * @param tenantId {string} - The tenant's ID to find by
     */
    editTenantHandler(tenantId) {
      // console.log('tenantId', tenantId);
      const targetTenantData = this.getTenants.find((tenantItem) => {
        return tenantItem.id === tenantId;
      });
      // console.log('targetTenantData');
      // console.log(targetTenantData);
      this.tenantData = targetTenantData;
      this.showTenantEditor = true;
    },

    /**
     * Trigger the api call to create a new tenant or save changes to an existing one accordingly
     * @param tenantData {Object} - the data of the Tenant to create or update
     * @returns {Promise<void>}
     */
    async saveTenant(tenantData) {
      this.saving = true;
      const editMode = !!this.tenantData && !!this.tenantData.id && this.tenantData.id.length > 0;
      try {
        // console.log('editMode', editMode);
        // console.log('tenantData', tenantData);
        if (!editMode) {
          // console.log('CREATING NEW TENANT');
          await NotificationService.Tenants.post(tenantData);
        } else {
          const params = {...tenantData, id: this.tenantData.id};
          await NotificationService.Tenants.put(params);
        }
        this.$notifier.success(`Tenant "${tenantData.name}" ${editMode ? 'updated' : 'created'} successfully.`);
        await this.prepareData();
        await this.constructTenantsTree();
        this.showTenantEditor = false;
      } catch (error) {
        console.error(error);
        this.$notifier.error(`Failed to ${editMode ? 'update' : 'create'} Tenant "${tenantData.name}".`)
      }
      this.saving = false;
    },
    /**
     * Enable a channel for the specified Tenant
     * @param channelData {Object} - the channel data to enable
     * @param tenantData {Object} - the tennant data to enable the channel for
     * @returns {Promise<void>}
     */
    async enableChannel(channelData, tenantData) {
      this.assigning = true;
      try {
        // console.log('Enabling Channel!!! - channelData');
        // console.log(channelData);
        // console.log('tenantData');
        // console.log(tenantData);
        await NotificationService.Tenants.addChannel(tenantData.id, channelData.id);
        // tenantData.channels.push(channelData.id);
        await this.prepareData();
        await this.constructTenantsTree();
      } catch (error) {
        console.error(error);
        this.$notifier.error(`Failed to assign Channel to "${tenantData.name}"`);
      }
      this.assigning = false;
    },
    /**
     * Close the Tenant editor and reset tenant selection
     */
    closeEditorHandler() {
      this.showTenantEditor = false;
      this.tenantData = null;
    },
  },
}
</script>

<style lang="scss" scoped>
.tenants-settings-cont {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.tenants-cont {
  display: flex;
  width: fit-content;
  margin: 16px auto;

  .tenants-list {
    margin-top: 24px;
    flex-direction: column;
    gap: 16px;
  }
}

.no-results {
  font-style: italic;
  text-align: center;
  opacity: 0.6;
  padding: 8px 16px;
}

.tenants-tree-cont {
  display: flex;
  flex-flow: column;
  row-gap: 8px;
  padding: 24px;

  .tenant-wrap {
    position: relative;

    .tenant-row {
      position: relative;
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      column-gap: 8px;
      justify-content: center;
      align-items: center;
      padding: 0 24px;

      .tenant-item {
        &.node {
          display: flex;
          flex-flow: row;
          justify-content: space-around;
          border-radius: 8px;
          padding: 4px 6px 4px 12px;

          &__name {
            display: flex;
            flex-flow: row;
          }

          &__action {
            margin-left: 8px;
          }
        }

        &.child {
          display: flex;
          flex-flow: row;
          justify-content: space-between;
          margin: 0 8px;
          padding: 2px 8px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          box-shadow: 0 2px 0 rgba(0, 0, 0, 0.5);

          &__name {
            display: flex;
            flex-flow: row;
            border-radius: 8px;
            padding: 4px 6px 4px 12px;
          }

          &__action {
            margin-left: 8px;
          }
        }
      }

      .tenant-channels {
        display: flex;
        justify-content: end;
      }
    }
  }
}


.main-dark {
  .tenant-row:hover {
    background: linear-gradient(
            to right,
            transparent 0%,
            rgba(0, 0, 0, 0.1) 10%, /* Adjust the semi-transparent color as needed */
            rgba(0, 0, 0, 0.1) 90%, /* This matches the semi-transparent part */
            transparent 100%
    );
  }

  .tenant-row:hover::before,
  .tenant-row:hover::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 2px; /* Adjust the border thickness as needed */
    background: linear-gradient(
            to right,
            transparent 0%,
            rgba(130, 96, 185, 0.4) 10%, /* Start of the green color */
            rgba(130, 96, 185, 0.4) 90%, /* End of the green color */
            transparent 100%
    );
  }

  .tenant-row:hover::before {
    top: 0; /* Position the top border */
  }

  .tenant-row:hover::after {
    bottom: 0; /* Position the bottom border */
  }

  .tenant-item.node {
    border: 1px solid #1c6e59 !important;
  }

  .tenant-item.child {
    background-color: rgba(250, 250, 250, 0.15);
  }
}

.main-light {
  .tenant-row:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .tenant-item.node {
    border: 1px solid #1c6e59 !important;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
  }

  .tenant-item.child {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>
